import { render, staticRenderFns } from "./OrderReviewForm.vue?vue&type=template&id=af9e02f4&"
import script from "./OrderReviewForm.vue?vue&type=script&lang=js&"
export * from "./OrderReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports